import { ICustomerRes } from '../interfaces/customer.interface';

export class CustomerDto implements ICustomerRes {
  customerId!: string;

  name!: string;

  email!: string;

  number!: string;

  business!: { id: string; name: string; ruc: string };
}
